var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailTo = function SvgEmailTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3874",
    "data-name": "Rectangle 3874",
    width: 20,
    height: 20,
    transform: "translate(-0.264 -0.264)",
    fill: "#fff",
    stroke: "#74757d",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_120",
    "data-name": "Mask Group 120",
    transform: "translate(0.264 0.264)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10641",
    "data-name": "Group 10641",
    transform: "translate(1.829 1.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M-23460.348-22474h12.832a.651.651,0,0,1,.652.65v8.5a.654.654,0,0,1-.652.654h-12.832a.651.651,0,0,1-.652-.654v-8.5A.648.648,0,0,1-23460.348-22474Zm12.176,1.3h-11.523v7.193h11.523Z",
    transform: "translate(23461 22473.998)",
    fill: "#74757d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M6.019,5.161a2.747,2.747,0,0,1-1.7-.563L-.225,1.028A2.007,2.007,0,0,1-.993-.255.653.653,0,0,1-.84-.775.653.653,0,0,1-.347-1H12.385a.653.653,0,0,1,.493.225.653.653,0,0,1,.153.52,2.006,2.006,0,0,1-.768,1.282L7.721,4.6A2.755,2.755,0,0,1,6.019,5.161ZM.97.306,5.126,3.573a1.554,1.554,0,0,0,1.788,0L11.068.306Z",
    transform: "translate(1.073 1.001)",
    fill: "#74757d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    transform: "translate(15.828 11.131) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M1.305,6.652H0V0H1.305Z",
    transform: "translate(2.105 0.653)",
    fill: "#74757d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M4.538,3.646,2.757,1.638.977,3.646,0,2.778,2.268.22a.653.653,0,0,1,.977,0l2.27,2.559Z",
    fill: "#74757d"
  })))))));
};
export default SvgEmailTo;